module.exports = __webpack_public_path__ + "img/LOGO_ombre.36182155.png";